import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { Profile } from './profile-entity';
import { AssabilMenu } from '../control-tables/assabil-menu';


export class ProfileAssabilMenu extends BaseEntity {

    profile         : Profile;
    assabilMenu     : AssabilMenu;
    hold            : boolean = false;

}